<template>
  <div
    v-if="isScreenLockSupported"
    class="c-recipe__cook-mode mb-6"
  >
    <button
      class="c-button flex items-center outline-none focus:outline-none"
      @click="toggle"
    >
      <span
        class="c-toggler"
        :class="{
          'is-selected': isSelected
        }"
      >
        <span class="c-toggler__icon">
          <span class="c-toggler__icon--inner" />
          <IconCookMode />
        </span>
      </span>
      <span>
        {{ model.text }}
      </span>
    </button>
  </div>
</template>

<script>
import { ref } from 'vue'
import IconCookMode from '@/assets/icons/cook-mode.svg'

export default {
  components: {
    IconCookMode
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  setup() {
    const isSelected = ref(false)
    let screenLock = null
    const isScreenLockSupported = 'wakeLock' in window.navigator

    if (!window.dataLayer) {
      window.dataLayer = []
    }

    const initScreenLock = async () => {
      try {
        screenLock = await navigator.wakeLock.request('screen')
        screenLock.addEventListener('release', () => {
          isSelected.value = false
        })
      } catch {
        isSelected.value = false
      }
    }

    const removeScreenLock = async () => {
      if (screenLock) {
        await screenLock.release()
        screenLock = null
      }
    }

    const trackCookModeToggle = (action) => {
      window.dataLayer.push({
        event: 'cookToggle',
        recipeTitle: window.gtmData?.recipeName,
        action
      })
    }

    const toggle = async () => {
      if (!isSelected.value) {
        await initScreenLock()
        isSelected.value = true
        trackCookModeToggle('enable')
      } else {
        await removeScreenLock()
        isSelected.value = false
        trackCookModeToggle('disable')
      }
    }

    return {
      isSelected,
      isScreenLockSupported,
      toggle
    }
  }
}
</script>
